<template>
	<v-card class="ma-2 mb-4">
		<v-toolbar :color="color" dark>
			<v-toolbar-title>
				<v-icon class="mr-3">{{ icon }}</v-icon>
				{{ header }}
			</v-toolbar-title>
			<v-spacer/>
			<v-btn @click="$emit('primary-button-action')" v-if="primaryButtonEnabled" :color="primaryButtonColor">
				<v-icon v-if="primaryButtonIcon">{{ primaryButtonIcon }}</v-icon>
				{{ primaryButtonText }}
			</v-btn>
		</v-toolbar>

		<v-alert :value="items !== null && items.length === 0" type="info">
			{{ emptyWarning }}
		</v-alert>

		<v-list two-line v-if="items !== null">
			<template v-for="(item, index) in items">
				<v-list-tile avatar :key="index">

					<v-list-tile-avatar>
						<slot name="avatar" v-bind:item="item" v-bind:index="index"/>
					</v-list-tile-avatar>

					<v-list-tile-content>
						<v-list-tile-title v-html="getTileTitle(item)"></v-list-tile-title>
						<v-list-tile-sub-title v-html="getTileSubtitle(item)"></v-list-tile-sub-title>
						<v-list-tile-action-text v-html="getTileActionText(item)"></v-list-tile-action-text>
					</v-list-tile-content>

					<slot name="actions" v-bind:item="item" v-bind:index="index"/>

				</v-list-tile>
			</template>
		</v-list>
	</v-card>
</template>
<script>
	export default {
		name: "EgrantyList",

		props: {
			header: {type: String, default: ""},
			icon: {type: String, default: "mail"},
			color: {type: String, default: "default"},
			emptyWarning: {type: String, default: "Brak elementów na liście"},
			items: {type: Array, default: () => [], required: true},
			getTileTitle: {type: Function, default: () => ""},
			getTileSubtitle: {type: Function, default: () => ""},
			getTileActionText: {type: Function, default: () => ""},

			primaryButtonIcon: {type: String},
			primaryButtonColor: {type: String, default: "default"},
			primaryButtonText: {type: String, default: ""},
			primaryButtonEnabled: {type: Boolean, default: false},
		},
	};
</script>
